import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { columnasFijas } from "../../../entregasZERealizadas/list/columns";
import { SelectedEntregaRealizadaZE } from "./types";

type Entity = SelectedEntregaRealizadaZE;
export interface Deps {
    onSeleccionar: (x: Entity, value: boolean) => void;
    onVer: (x: Entity) => void;
}
export function columnas(deps: Deps) {
    const ret: kea.Grid2Column<Entity>[] = [
        { title: "", key: "seleccionar", cell: x => ({ data: x.Selected, view: () => <kea.Checkbox value={x.Selected} onChange={sel => deps.onSeleccionar(x, sel)} /> }) },
        kea.columnaBotones([
            {
                iconClass: fa("eye"),
                onClick: deps.onVer,
                tooltip: "Ver detalle"
            }
        ]),
        { title: "Total a pagar FXC", cell: x => ({ data: kea.formatCurrency(x.TotalFXC) }) },
        { title: "Cantidad de acuses", cell: x => ({ data: x.CantidadAcuses }) },
        ...columnasFijas
    ];

    const rowStyleCol = kea.applyRowStyleToColumns(ret, (item: Entity) =>
        item.Liberada ? { background: "#F7F7D4" } : {});
    return rowStyleCol;
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/liberacionentregasZE/components/multientregas/columns.tsx